import * as React from 'react';
import { JSSClassesProps } from 'react-jss';

import { IconSunset } from 'sletat-ui-components/lib/SVGIcons/IconSunset';

import { ComponentJSSClasses } from './styles';


export interface NoPhotoPlaceholderProps {}

export interface StyledNoPhotoPlaceholderProps extends NoPhotoPlaceholderProps, JSSClassesProps<ComponentJSSClasses> {}

export function NoPhotoPlaceholder(props: StyledNoPhotoPlaceholderProps) {
    const { classes } = props;

    return (
        <div className={classes.container}>
            <img
                className={classes.image}
                src={'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNiA5Ij48cmVjdCBmaWxsPSIjZTZlOWVhIiB3aWR0aD0iMTYiIGhlaWdodD0iOSIvPjwvc3ZnPgo='}
                alt={'Нет фото'}
            />
            <div className={classes.wrap}>
                <IconSunset width={114} height={114} fill={'#999'} />
                <b className={classes.text}>Нет фото</b>
            </div>
        </div>
    );
}
